import Block from "../../../components/Block/Block"
import FadeIn from "../../../components/FadeIn/FadeIn"

import style from './socialblock.module.scss'

import tg from '../../../assets/tg.png'
import vk from '../../../assets/vk.png'
import max from '../../../assets/max.png'

const SocialBlock = () => {
    return (
        <Block
            flexDirection='column'
            justifyContent='center'
            alignItems='start'
            width="75%"
            height='fit-content'
            background="rgba(255, 255, 255, 0.85)"
            header='МЫ В СОЦИАЛЬНЫХ СЕТЯХ'
        >
            <FadeIn>
            <div className={style.content}>
                <div className={style.wrapperSocials}>
                    <div className={style.social}>
                        <img className={style.tg} src={tg} alt='Telegram' />
                        <span className={style.text}>
                             https://t.me/sambo_23rus
                        </span>
                    </div>

                    <div className={style.social}>
                        <img className={style.vk} src={vk} alt='VK' />
                        <span className={style.text}>
                            https://vk.com/club227351180
                        </span>
                    </div>

                    <div className={style.social}>
                        <img className={style.max} src={max} alt='MAX' />
                        <span className={style.text}>
                            https://max.ru/id2311365872_gos
                        </span>
                    </div>
                </div>
            </div>
            </FadeIn>
        </Block>
    )
}

export default SocialBlock